<template>
  <div class="w-full">
    <h3 class="text-dark bg-white rounded-sm text-center uppercase">
      Order Details
    </h3>
    <job-container
      v-for="(job, i) in jobs"
      :key="i"
      :job="job"
      :material-options="materialOptions"
      :unit-options="unitOptions"
      @remove-job="removeJob(i)"
    >
      <job-form
        v-if="job.status === undefined"
        :job="job"
        :index="i"
        :material-options="materialOptions"
        :unit-options="unitOptions"
      />
      <div class="flex flex-col md:flex-row ">
        <job-updates
          v-if="job.status"
          :price="job.price"
          :job-status="job.status"
          :job-id="job.combo_id"
          :job="job"
        />
        <img
          v-if="job && job.demoImage"
          class=" flex-1 w-3/4 md:w-1/5 max-w-sm m-5"
          :src="job.demoImage"
        >
      </div>
    </job-container>
    <div class="flex flex-row w-full">
      <h3
        v-if="order.status"
        class="w-full text-dark bg-white rounded-sm text-left pl-3"
      >
        Status: {{ order.status }}
        {{
          order.status === 'Expired'
            ? '&#8212; This estimate was completed over 48 hours ago.  Please "Start Over" and submit a new order.'
            : ''
        }}
        {{
          order.status === 'Requested'
            ? "&#8212; We're working you into our production schedule. Once we've verified your place in line, we'll ask you to submit a payment to finalize your order."
            : ''
        }}
      </h3>
      <h3
        v-if="orderTotalPrice"
        class="w-full text-dark bg-white rounded-sm text-right pr-3"
      >
        Service Discount:
        {{
          servicesSubtotal
            ? Math.round(100 * (1 - servicesFinalPrice / servicesSubtotal))
            : 0
        }}% Total:
        {{ toCurrency(orderTotalPrice) }}
      </h3>
    </div>
    <MailingListCheckbox
      v-if="$route.path === '/'"
      @handle-change-newsletter="changeNewsletter"
      :newsletter="newsletter"
    />
  </div>
</template>
<script>
import JobForm from './JobForm.vue'
import JobContainer from './JobContainer.vue'
import JobUpdates from './JobUpdates.vue'
import GeneralMixins from '../mixins/GeneralMixins.vue'
import CostFactorMixins from '../mixins/CostFactorMixins.vue'
import MailingListCheckbox from './MailingListCheckbox.vue'
export default {
  name: 'OrderDetails',
  components: { JobForm, JobContainer, JobUpdates, MailingListCheckbox },
  mixins: [GeneralMixins, CostFactorMixins],
  props: {
    servicesSubtotal: { type: Number },
    servicesFinalPrice: { type: Number },
    orderTotalPrice: { type: Number },
    newsletter: {type: Boolean },
    jobs: {
      type: Array,
      default: () => [],
    },
    order: {
      type: Object,
      default: null,
    },
    discountOptions: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      materialOptions: [],
      unitOptions: [
        { id: 1, name: 'inch', short: 'in' },
        /*'feet', 'centimeter',*/

        { id: 0.03937007874, name: 'millimeter', short: 'mm' },
      ],
    }
  },
  created () {
    this.getMaterials()
  },
  methods: {
    removeJob (i) {
      this.jobs.splice(i, 1)
    },
    getMaterials () {
      let self = this
      this.$api.Materials.getMaterials()
        .then(res => {
          if (res.status === 200) {
            self.materialOptions = res.data.materials
          } else {
            throw new Error('Error: ' + res.message)
          }

          // sort by name
          self.materialOptions.sort((a, b) => (a.name > b.name) ? 1 : -1)

          // sort by thickness
          this.materialOptions.sort((a, b) => {
            const shortestMaterialName = 'Brass 260'
            const shortLength = shortestMaterialName.length

            // make sure the starts of the strings match
            // so we know they are the same material
            if (a.name.slice(0, shortLength) !== b.name.slice(0, shortLength)) {
              return 0
            }

            // sort by thickness
            else {
              if (a.thickness > b.thickness) return 1
              else return -1
            }
          })
        })
        .catch(err => {
          self.$swal(err.message)
        })
    },
    changeNewsletter (newsletter) {
      this.$emit('handle-change-newsletter', newsletter)
    }
  },
}
</script>
